export default function (value) {
    return value ? value.toUpperCase() : value;
}